import React from "react";
import MenuItem from "@material-ui/core/MenuItem";

const YearMenuItems = () => {
  const currentYear = new Date().getFullYear();
  const startYear = 2020;
  const years = [];

  for (let year = startYear; year <= currentYear; year++) {
    years.push(
      <MenuItem key={year.toString()} value={year.toString()}>
        {year}年
      </MenuItem>
    );
  }

  return years;
};

export default YearMenuItems;
